import React, { useMemo } from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useActivities } from "../../../context/ActivitiesContext";
import { API_GAME } from "../../../constants/api";
import * as routes from "../../../constants/routes";
import DashboardCard from "../DashboardCard";

const MAX_GAMES = 3;
const MAX_GAMES_MOBILE = 2

const GamesGrid = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$isMobile",
})(({ $isMobile }) => ({
  display: "grid",
  gridTemplateColumns: `repeat(${$isMobile ? MAX_GAMES_MOBILE : MAX_GAMES}, 1fr)`,
  gap: "1.5rem",
  width: "100%",
}));

const GameImage = styled("img")({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  borderRadius: "0.55rem",
  objectFit: "contain",
  cursor: "pointer",
  transition: "transform 0.2s ease",
  "&:hover": {
    transform: "scale(1.05)",
  },
});

const RecommendedGamesSection = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { activities, setInfoActivity } = useActivities();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const recommendedGames = useMemo(() => {
    if (!activities) return [];

    const limit = isMobile ? MAX_GAMES_MOBILE : MAX_GAMES;

    return activities
      .filter((act) => act.type === "jogo")
      .sort((a, b) => Number(b.id) - Number(a.id))
      .slice(0, limit);
  }, [activities, isMobile]);

  const handleGameClick = (game) => {
    setInfoActivity(game);
  };

  const handleViewAll = () => {
    navigate(routes.R_ACTIVTS);
  };

  const getGameImage = (game) => {
    return `${API_GAME}/${game.path}/jogo_imagem_.jpg`;
  };

  if (!recommendedGames.length) {
    return null;
  }

  return (
    <DashboardCard
      title={t("global.recommended_games")}
      action={{
        type: 'text-with-icon',
        label: t("global.view_all"),
        onClick: handleViewAll
      }}
      onClick={handleViewAll}
    >
      <GamesGrid $isMobile={isMobile}>
        {recommendedGames.map((game) => (
          <GameImage
            key={game.id}
            src={getGameImage(game)}
            alt={game.name}
            onClick={(e) => { e.stopPropagation(); handleGameClick(game); }}
            onError={(e) => {
              e.target.style.display = "none";
            }}
          />
        ))}
      </GamesGrid>
    </DashboardCard>
  );
};

export default RecommendedGamesSection;
